/**
 * Short context for brokers on how funding timing relates to milestones (not legal advice).
 * @param {string | undefined} stateCode Two-letter state
 * @returns {string | null}
 */
export function getFundingTimingNote(stateCode) {
  const s = (stateCode || '').trim().toUpperCase();
  if (!s || s.length !== 2) {
    return 'Disbursement and recording order depend on state practice, title, and investor. Compare “Recorded mortgage” and “Funded” below to see UFF’s pace on this file.';
  }
  // Broad patterns: many Western states use escrow / recording-dependent funding; many non-attorney closing states use table funding.
  if (['CA', 'WA', 'OR', 'AZ', 'NV'].includes(s)) {
    return 'In many Western markets, escrow closes first and funds often follow recording or lender conditions (sometimes called dry funding). Delays after signing usually show up in recording or funding milestones—not as UFF sitting on the file.';
  }
  if (['TX', 'GA', 'NC', 'SC', 'TN', 'IL', 'OH', 'PA', 'NJ', 'FL'].includes(s)) {
    return 'In many of these states, closing often uses table or simultaneous funding; your “Funded” milestone may align closely with closing. If recording trails funding, that is usually title/county timing.';
  }
  return 'Funding relative to closing and recording varies by state and investor. Use the timeline below to see where time accumulated on this loan.';
}
